import { getTouchscreenMode } from "@/services/device.js";
import useSiteNavigator from "@/util/useSiteNavigator.js";
import { useHttpStore } from "@/stores/http/index.ts";
import { useStore } from "vuex";

/*
If you have one-time app set up tasks they probably belong in the useInitApp hook.
This function should be reserved for data loading tasks.
 */

export default function useAppInit() {
  const store = useStore();
  const httpStore = useHttpStore();
  const { initSiteNavigator } = useSiteNavigator();

  async function appInit(to) {
    const shouldLoadAuthToken =
      to.meta.adminOnly || to.meta.cmsOnly || to.params.styleid === "lookup";

    if (shouldLoadAuthToken) {
      // If we're on an admin or CMS page or redirecting from login
      // we need to load the auth token here.
      // If not, we wait until the afterEach callback where it doesn't
      // impact loading speed.
      await httpStore.loadToken();
    }

    await store.dispatch("api/setSiteId", to.params.styleid);

    const siteId = store.getters.getStyleID ?? "default";

    if (!siteId) {
      return;
    }

    const isTouchScreen = getTouchscreenMode(siteId);

    store.dispatch("setTouchScreen", isTouchScreen);

    await store.dispatch("api/fetchStylingData");

    await initSiteNavigator(store);

    if (shouldLoadAuthToken) {
      await store.dispatch("api/fetchUser");
    }
  }

  return {
    appInit,
  };
}
